import { useEffect } from "react";
import { useLocation } from "react-router-dom";

import { absoluteUrl, defaultOgImageUrl } from "../config/site";
import { applySeoHead, cleanupSeoHead } from "../seo/head";
import { resolveSeoMeta } from "../seo/meta";
import { buildLandingStructuredData } from "../seo/structuredData";

/**
 * Syncs document title, meta tags, canonical URL, Open Graph, Twitter cards,
 * and JSON-LD structured data from the current route.
 */
export function SeoHead(): null {
  const { pathname } = useLocation();

  useEffect(() => {
    const meta = resolveSeoMeta(pathname);
    const canonicalUrl = absoluteUrl(meta.canonicalPath);
    const ogImageUrl = defaultOgImageUrl();
    const jsonLd = meta.structuredData ? buildLandingStructuredData() : [];

    applySeoHead({ meta, canonicalUrl, ogImageUrl, jsonLd });

    return () => {
      cleanupSeoHead();
    };
  }, [pathname]);

  return null;
}
